import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MobileContextMenu from '../MobileContextMenu';
import windowIsBelowSize from '../utils/window-is-below-size';
import { getMenuData, getArrowData } from '../utils/popover-menu-origin-calculator';
import { getClassName } from '../utils/get-class-name';
import { MenuContainer, ArrowFill, ArrowBorder, PopoverMenu } from '../PopoverButton/PopoverButton';
import TscThemeName from '../constants/TscThemeName';
import tscStyles from '../constants/TscStyles';
import TscPopoverOrigin from '../constants/TscPopoverOrigin';

var ContextMenu = function ContextMenu(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$closeMenuOnClick = _ref.closeMenuOnClick,
      closeMenuOnClick = _ref$closeMenuOnClick === void 0 ? false : _ref$closeMenuOnClick,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === void 0 ? '15rem' : _ref$maxHeight,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? '15rem' : _ref$maxWidth,
      mobileMenuTitle = _ref.mobileMenuTitle,
      _ref$mobileZindex = _ref.mobileZindex,
      mobileZindex = _ref$mobileZindex === void 0 ? 1 : _ref$mobileZindex,
      onClose = _ref.onClose,
      _ref$origin = _ref.origin,
      origin = _ref$origin === void 0 ? TscPopoverOrigin.bottom : _ref$origin,
      _ref$showArrow = _ref.showArrow,
      showArrow = _ref$showArrow === void 0 ? false : _ref$showArrow,
      _ref$showMenu = _ref.showMenu,
      showMenu = _ref$showMenu === void 0 ? true : _ref$showMenu,
      _ref$themeName = _ref.themeName,
      themeName = _ref$themeName === void 0 ? TscThemeName.dawn : _ref$themeName,
      _ref$useMobileMenu = _ref.useMobileMenu,
      useMobileMenu = _ref$useMobileMenu === void 0 ? true : _ref$useMobileMenu;
  var isMobileMenu = useMobileMenu && windowIsBelowSize(tscStyles.breakpoints.contextMenuBreakpoint);
  var menuElement;

  if (isMobileMenu) {
    menuElement = _jsx(MobileContextMenu, {
      className: className,
      visible: showMenu,
      onClose: onClose,
      zIndex: mobileZindex,
      themeName: themeName,
      title: mobileMenuTitle,
      children: _jsx(PopoverMenu, {
        className: getClassName(className, 'popover-menu'),
        maxHeight: maxHeight,
        themeName: themeName,
        children: children
      })
    });
  } else {
    menuElement = _jsxs(MenuContainer, {
      className: getClassName(className, null, 'menu-container'),
      visible: showMenu,
      data: getMenuData(origin, showArrow),
      children: [showArrow && _jsx(ArrowBorder, {
        className: getClassName(className, 'arrow-border'),
        data: getArrowData(origin)
      }), showArrow && _jsx(ArrowFill, {
        className: getClassName(className, 'arrow-fill'),
        data: getArrowData(origin)
      }), _jsx(PopoverMenu, {
        className: getClassName(className, 'popover-menu'),
        onClick: function onClick(e) {
          return closeMenuOnClick && onClose && onClose(e);
        },
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        themeName: TscThemeName.dawn,
        children: children
      })]
    });
  }

  return menuElement;
};
/** @component */


export default ContextMenu;